<script>
	// NPM Modules
	import { navigate } from 'svelte-navaid';
	// Stores
	import ClassificationStore from '@/Stores/Racing/ClassificationStore.js';
	// Services
	import { getUrlParameter, setUrlParameter, paginationBuilder } from '@/Services/Helpers.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import Icon from '@/Components/Icon.svelte';
	import Pagination from '@/Components/Pagination.svelte';
	// Constants
	import { BetCategory } from '@/Constants/Bet';
	import Helmet from '@/Components/Helmet.svelte';

	$: links = $ClassificationStore.count() && paginationBuilder(ClassificationStore.getPagination());

	let pageNo = getUrlParameter('page') || 1;
	let loading = getClassifications();

	function changePage(e) {
		if (e) {
			pageNo = e.detail.page;
			getClassifications();
			setUrlParameter('page', pageNo);
		}
	}

	function getClassifications() {
		return ClassificationStore.getClassifications(BetCategory.Racing, { size: 50, number: pageNo });
	}

	function click(id) {
		navigate(`/racing/classifications/${id}`);
	}
</script>

<Helmet title="Racing classifications" />

<div>
	{#await loading}
		<Loading />
	{:then}
		<div>
			<!-- Page Header -->
			<div class="flex flex-col items-center w-full p-4 mb-4 text-sm bg-white border-b md:py-2">
				<div class="flex items-center w-full">
					<h1 class="text-xl font-bold">Classification List</h1>
				</div>
			</div>
			<!-- /Page Header -->
			<div class="p-2 mx-4 bg-gray-100 rounded">
				<Pagination {links} on:click={changePage} className="mt-2" />
				<div class="overflow-x-auto rounded">
					<table class="w-full whitespace-nowrap">
						<thead>
							<tr class="text-xs text-left text-gray-500 uppercase">
								<th class="px-6 pt-5 pb-4 font-medium">Classification</th>
								<th class="px-6 pt-5 pb-4 font-medium" />
							</tr>
						</thead>
						<tbody class="bg-white">
							{#if !$ClassificationStore.count()}
								<tr>
									<td class="px-6 py-4 text-center border-t" colspan="5"> No classifications found. </td>
								</tr>
							{:else}
								{#each $ClassificationStore.all() as classification (classification.id)}
									<tr
										on:click={() => click(classification.id)}
										class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100"
									>
										<td class="p-4 px-6 font-semibold border-t">
											{classification.name}
										</td>
										<td class="w-px px-6 border-t">
											<Icon name="chevron-right" classes="block w-4 h-4 text-gray-400 inline" />
										</td>
									</tr>
								{/each}
							{/if}
						</tbody>
					</table>
				</div>
				<Pagination {links} on:click={changePage} className="my-3" />
			</div>
		</div>
	{/await}
</div>
